import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cw-paginator',
    templateUrl: 'paginator.component.html',
    styleUrls: ['paginator.component.scss'],
    standalone: false,
})
export class PaginatorComponent {
    @Input() current = 0;
    @Input() total = 0;
    @Input() pageSize = 1;
    @Output() currentChange = new EventEmitter<number>();

    controlPage = 0;

    constructor(private cdr: ChangeDetectorRef) {}

    onCurrentPageChanged(e: number): void {
        if (this.controlPage !== e) {
            this.currentChange.emit(e);
            this.controlPage = e;
            this.current = e;

            this.cdr.detectChanges();
        }
    }
}
